import React from 'react'
import classes from "./style.module.scss";
import { Images } from '../../../../assets';

const RewardsList = ({ redeemDetails }) => {
    const header = ["ID", "Title", "Image", "Quantity", "Points", "Total Points"];

    return (
        <>
            <div className={`${classes.enquiryCardWrapper} mb-4`}>
                <div className={`${classes.detailsWrapper}`}>
                <div className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}>Redeem List</div>
                    <table>
                        <thead>
                            <tr>
                                {header.map((it) => (
                                    <th key={it}>{it}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {redeemDetails?.map((it, index) => (
                                <tr key={index}>
                                    <td>{it?.id}</td>
                                    <td>{it?.title}</td>
                                    <div className='h-[30px]'>
                                    <img src={it?.image || Images.noImage} className='w-[100%] h-[100%]' style={{ objectFit: 'contain' }}/>
                                    </div>
                                    <td>{it?.quantity}</td>
                                    <td>{it?.points}</td>
                                    <td>{it?.quantity * it?.points}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default RewardsList;
